export function getValue(parametersValue, defaultValue) {
  return parametersValue === undefined ? defaultValue : parametersValue;
}
